import _export from "../internals/export";
import _getBuiltIn from "../internals/get-built-in";
import _validateArgumentsLength from "../internals/validate-arguments-length";
import _toString from "../internals/to-string";
import _urlConstructorDetection from "../internals/url-constructor-detection";
var $ = _export;
var getBuiltIn = _getBuiltIn;
var validateArgumentsLength = _validateArgumentsLength;
var toString = _toString;
var USE_NATIVE_URL = _urlConstructorDetection;
var URL = getBuiltIn("URL");

// `URL.parse` method
// https://url.spec.whatwg.org/#dom-url-canparse
$({
  target: "URL",
  stat: true,
  forced: !USE_NATIVE_URL
}, {
  parse: function parse(url) {
    var length = validateArgumentsLength(arguments.length, 1);
    var urlString = toString(url);
    var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
    try {
      return new URL(urlString, base);
    } catch (error) {
      return null;
    }
  }
});
export default {};